import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { useUser } from "../../../context/user-context";
import { toast } from "react-hot-toast";
import { getNetworkLabel } from "../../../constants/constants";

const SelectDNetwork = ({
  setOpenDeposit,
  depositCoinName,
  depositNetworks,
  setOpenDepositNetwork,
  setOpenDepositAddy,
  setDepositNetworkName,
}: any) => {
  const [networkSelect, setNetworkSelect] = useState<number>(100);
  const { userDetails } = useUser();
  const [disableProceed, setDisableProceed] = useState<boolean>(false);
  // console.log(userDetails);

  useEffect(() => {
    if (
      !userDetails?.user?.wallets ||
      userDetails?.user?.wallets?.length === 0
    ) {
      setDisableProceed(true);
      toast.error(
        "You don't have any wallet to deposit to, please refresh the page"
      );
    } else {
      setDisableProceed(false);
    }
  }, [userDetails]);

  return (
    <div className="fixed inset-0  flex font-manrope overflow-auto pb-16 justify-start items-start pt-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenDepositNetwork(false);
              setOpenDeposit(true);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Deposit {depositCoinName}
          </h4>
        </div>
        <h4 className="text-gray-900 dark:text-gray-100 text-[16px] mt-4">
          Select Network
        </h4>
        <div className="w-full mt-6">
          {depositNetworks.map((network: any, index: any) => (
            <div
              key={index}
              className="w-full flex mt-8 justify-between items-center"
            >
              <div className="flex items-center gap-3">
                <div
                  onClick={() => {
                    if (networkSelect === index) {
                      setNetworkSelect(100);
                      setDepositNetworkName("");
                    } else {
                      setNetworkSelect(index);
                      setDepositNetworkName(network.name);
                    }
                  }}
                  className={`w-[20px] h-[20px] p-1 flex justify-center items-center rounded-full  ${
                    networkSelect === index
                      ? "border-[#5E91FF]  "
                      : "bg-transparent border-[#505050]"
                  } border `}
                >
                  <div
                    className={`w-full h-full rounded-full  ${
                      networkSelect === index
                        ? " bg-[#5E91FF] "
                        : "bg-transparent "
                    } `}
                  />
                </div>
                <h4 className="text-[14px] dark:text-gray-300 uppercase text-black tracking-widest">
                  {getNetworkLabel(network.name)}
                </h4>
              </div>
            </div>
          ))}
        </div>
        <button
          disabled={networkSelect === 100 || disableProceed}
          onClick={() => {
            setOpenDepositNetwork(false);
            setOpenDepositAddy(true);
          }}
          className={`w-full h-[52px] rounded-[18px] mt-16 ${
            networkSelect === 100
              ? "dark:text-gray-400 dark:bg-gray-600 bg-gray-400 text-gray-100"
              : "bg-secondary_button text-white"
          }  flex justify-center items-center  font-semibold`}
        >
          Proceed
        </button>
      </div>
    </div>
  );
};

export default SelectDNetwork;
